<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-9 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Stawki</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa</th>
                  <th>Stawka w PLN</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(stawka, index) in stawki" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ stawka.name }}</td>
					<td>
					  <div v-if="editingId === stawka.id" class="input-group">
						<input
						  v-model="stawka.stawka"
						  type="text"
						  inputmode="decimal"
						  class="form-control"
						/>
						<span class="input-group-text text-muted">PLN</span>
					  </div>

					  <span v-else>
						{{ stawka.stawka }}
						<span class="text-muted">PLN</span>
					  </span>
					</td>
                  <td>
                    <button v-if="editingId === stawka.id" @click="updateStawka(stawka)" class="btn btn-sm btn-success me-2">
                      Zapisz
                    </button>
                    <button v-else @click="editStawka(stawka.id)" class="btn btn-sm btn-outline-info me-2"><i
                        class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/Kadry/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    stawki: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null
    };
  },
  methods: {
    editStawka(id) {
      this.editingId = id;
    },
		successMsg(resp) {
			Toast.fire({
				position: 'top-end',
				toast: true,
				icon: 'success',
				title: 'Sukces!',
				html: resp,
				showClass: { popup: 'animate__animated animate__fadeInDown' },
				hideClass: { popup: 'animate__animated animate__fadeOutUp' },
				timer: 2500,
				timerProgressBar: true,
				showConfirmButton: false,
				showCloseButton: true
			});
		},
	updateStawka(stawka) {
	  const wartosc = String(stawka.stawka)
		  .replace(',', '.')
		  .trim();
	  this.$inertia.put(
		route('kadry.stawka.update', stawka.id),
		{
		  stawka: wartosc
		},
		{
		  onSuccess: () => {
			this.editingId = null;
			this.successMsg('Stawka została zaktualizowana.');
		  }
		}
	  );
	}
  }
};
</script>

